module.exports = __webpack_public_path__ + "static/media/message_icon.2d4c39ef.svg";